import MenusContainer from "../../features/menus/components/MenusContainer";

const MenusPage = () => {
  return (
    <div className="page-body pt-3">
      <MenusContainer />
    </div>
  );
};

export default MenusPage;
